<template>
  <div class="filters-row">
    <div>
      <span class="filters-row__title">{{ title }}</span>
      <span
        v-if="actualSelectedValues.length"
        class="filters-row__quantity"
      >({{ actualSelectedValues.length }})</span>
    </div>

    <span
      v-if="selectedValuesString"
      class="filters-row__label"
    >{{ selectedValuesString }}</span>

    <UIIcon
      class="filters-row__arrow"
      name="arrow"
    />
  </div>
</template>

<script lang="ts" setup>
import UIIcon from '~/components/ui/UIIcon.vue';
import { useStateSelectedFilters } from '~/services/catalogFilter/useAvailableFilters';
import { TCheckboxQueryParamName } from '~/types/filters';
import { useCategoryTree } from '~/store/categoryTree';

const props = defineProps<{
  title: string
  rowKey?: TCheckboxQueryParamName
  data?: object
  selectedValues?: number[]
}>();

const { t } = useI18n();
const selectedFilters = useStateSelectedFilters();
const { getCategoryById } = useCategoryTree();
const actualSelectedValues = computed(() => {
  const selectedValues = props.selectedValues ?? [];

  if (props.rowKey === 'categories') {
    return selectedValues;
  }

  return selectedValues.reduce((acc, id) => {
    const item = props.data?.allValuesMap.get(`${id}`);

    if (item) {
      acc.push(item);
    }

    return acc;
  }, []);
});
const selectedValuesString = computed(() => {
  if (props.rowKey === 'price') {
    const { startPrice, endPrice } = selectedFilters.value;
    const startPriceText = startPrice ? `${t('common.from')} ${startPrice}` : '';
    const endPriceText = endPrice ? `${t('common.to')} ${endPrice}` : '';

    return `${startPriceText} ${endPriceText}`;
  }

  if (props.rowKey === 'categories') {
    return props.selectedValues?.map((id) => getCategoryById(id!)?.displayName ?? '').join(', ');
  }

  if (!props.data || !props.selectedValues?.length) return '';

  return actualSelectedValues.value.map(({ name, value }) => name ?? value).join(', ');
});
</script>

<style scoped lang="scss">
.filters-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px 10px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  position: relative;

  &__title {
    color: #202020;
  }

  &__label,
  &__quantity {
    color: #bdbdbd;
    font-size: 12px;
  }

  &__label {
    flex: 1;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  &__quantity {
    margin: 0 4px;
  }

  &__arrow {
    position: absolute;
    right: 0;
    top: calc(50% - 6.5px);
    transform: rotateZ(270deg);
  }
}
</style>
